@if (!mixedMode()) {
<div class="mb-4 sm:mb-6">
    <div class="flex flex-col justify-between gap-3 sm:gap-4 items-start"
        [ngClass]="{'sm:flex-row sm:items-center': !commonService.isPanelOpen()}">
        <div class="flex-1" [ngClass]="{'w-full': commonService.isPanelOpen(), 'w-auto': !commonService.isPanelOpen()}">
            <h1 class="text-xl sm:text-2xl font-medium text-[#141437] dark:text-white backdrop-blur-sm">Daily Cron
                Payments
            </h1>
            <p class="text-slate-600 dark:text-slate-400 text-xs sm:text-sm backdrop-blur-sm mt-1">Comprehensive
                analysis of daily cron
                and try again cron payments and trends</p>
        </div>
        @if (isDenefits()) {
        <div class="flex-shrink-0 w-full overflow-visible relative z-10"
            [ngClass]="{'flex justify-end': commonService.isPanelOpen(), 'sm:w-auto': !commonService.isPanelOpen()}">
            <button (click)="openAiAssistant()"
                class="daily-cron-ai-btn gradient-border bg-white dark:bg-surface-1 text-[#141437] dark:text-white text-sm lg:text-xs font-medium px-5 lg:px-3 py-2.5 lg:py-3 rounded-xl transition-all duration-200 shadow-[0px_6px_12px_-6px_#AD46FF] hover:shadow-[0px_7px_12px_-5px_#AD46FF] flex items-center gap-2 disabled:opacity-50 cursor-pointer disabled:cursor-not-allowed">
                <app-icon-v2 name="sparkles" [size]="16" />
                Ask Prism AI
            </button>
        </div>
        }
        <div class="flex items-center gap-3 flex-shrink-0">
            <!-- Customize Layout entry point — opens the inline popup that
                 lets the user reorder, resize (4/6/8/12 width), and toggle
                 visibility for every customizable section on this page. -->
            <button type="button" (click)="openCustomizeLayout()"
                class="flex items-center gap-1.5 px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium hover:border-[#AD46FF]/60 hover:text-[#AD46FF] transition-all duration-200 shadow-sm whitespace-nowrap">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect width="7" height="7" x="3" y="3" rx="1" />
                    <rect width="7" height="7" x="14" y="3" rx="1" />
                    <rect width="7" height="7" x="14" y="14" rx="1" />
                    <rect width="7" height="7" x="3" y="14" rx="1" />
                </svg>
                Customize layout
            </button>
        </div>
    </div>
</div>
}

<div [class]="mixedMode() ? 'unified-tile-body h-full' : ''">
    <div class="min-w-0" [ngClass]="{'overflow-x-hidden': commonService.isPanelOpen(), 'h-full': mixedMode()}">
        <!-- ─────────────────────────────────────────────────────────────────────────
     OVERVIEW Customizable Grid
     Customizable 12-col grid wrapping the "most recent" cron stats and
     the yearly milestone timeline. Cards render with the persisted
     col-span / order / visibility from `layoutMap`. Defaults preserve
     the original 6/6 split for the two cron cards and full-width for
     the timeline so the page looks the same on first load.
─────────────────────────────────────────────────────────────────────────── -->
        <div class="grid grid-cols-12 gap-4 md:gap-6 grid-flow-row-dense items-stretch">
            @for (sec of overviewSections(); track trackSection($index, sec)) {
            <div [ngClass]="getSectionColClass(sec)" class="group relative">

                <!--  Custom Dashboard -->
                @if (!mixedMode() && canPinToCustomDashboard(sec)) {
                <button type="button" (click)="addToCustomDashboard(sec); $event.stopPropagation()"
                    [disabled]="isAddingToCustomDashboard(sec)"
                    class="group/pin absolute cursor-pointer top-2 right-2 z-20 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                    [ngClass]="isAddedToCustomDashboard(sec)
            ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
            : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                    [attr.aria-label]="isAddedToCustomDashboard(sec) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                    [title]="isAddedToCustomDashboard(sec) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                    @if (isAddingToCustomDashboard(sec)) {
                    <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                    </svg>
                    <span>{{ isAddedToCustomDashboard(sec) ? 'Removing' : 'Adding' }}&hellip;</span>
                    } @else if (isAddedToCustomDashboard(sec)) {
                    <!-- Pinned state: pill is permanently visible at top-right
             (state indicator). At rest it stays compact — just the
             green check icon — so the card title beneath stays fully
             readable. Hovering the pill morphs it open (max-width
             animates) and flips the affordance from "Added" (check)
             to "Remove from Custom Dashboard" (minus) so the toggle
             action remains discoverable. The negative margin on the
             label cancels the flex gap while collapsed so the
             at-rest pill looks like a tight icon-only circle. -->
                    <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                        height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                        height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path d="M5 12h14" />
                    </svg>
                    <span
                        class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                        from Custom Dashboard</span>
                    } @else {
                    <!-- Not-pinned state: pill is hidden at card-rest (opacity-0).
             On card hover it fades in as a compact "+" icon only.
             Hovering the icon itself then morphs the pill open
             (max-width animates) to reveal the full "Pin to Custom
             Dashboard" label. The negative margin on the label
             collapses the flex gap when the label is closed so the
             at-rest icon stays visually centred in a small circle. -->
                    <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M5 12h14" />
                        <path d="M12 5v14" />
                    </svg>
                    <span
                        class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                        to Custom Dashboard</span>
                    }
                </button>
                }

                @switch (sec.id) {

                @case (SectionId.LAST_ATTEMPT) {
                <div class="flex flex-col gap-4 h-full">
                    <div
                        class="relative w-full flex-1 bg-gradient-to-br from-slate-900 to-slate-800 rounded-lg shadow-lg border border-white/10 p-4 overflow-hidden group flex flex-col">
                        @if(isLoadingMostRecentDailyCron()) {
                        <div
                            class="absolute inset-0 z-50 flex items-center justify-center bg-slate-900/80 backdrop-blur-sm rounded-lg">
                            <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
                        </div>
                        }
                        <!-- CIRCLES AND BACKGROUND EFFECTS -->
                        <div
                            class="absolute inset-0 bg-gradient-to-tr from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                        </div>
                        <div
                            class="absolute -top-24 -right-24 w-64 h-64 bg-blue-500 rounded-full blur-3xl opacity-20 group-hover:opacity-30 transition-opacity duration-500">
                        </div>
                        <div
                            class="absolute -bottom-24 -left-24 w-64 h-64 bg-blue-500 rounded-full blur-3xl opacity-10 group-hover:opacity-20 transition-opacity duration-500">
                        </div>

                        <!-- HEADER -->
                        <div class="relative z-10 flex items-center justify-between mb-6">
                            <div class="flex items-center gap-3">
                                <div
                                    class="bg-white/10 backdrop-blur-xl p-2 rounded-lg border border-white/20 shadow-lg text-blue-400">
                                    <app-icon name="activity" class="text-white" [size]="16"></app-icon>
                                </div>
                                <div>
                                    <h3 class="text-white text-md font-black">Daily Cron Last Attempt</h3>
                                    <p class="text-white/60 text-xs p-0 m-0">Automated Payment Processing</p>
                                </div>
                            </div>

                            <div
                                class="flex items-center gap-2 rounded-lg bg-white/10 backdrop-blur-xl font-medium border border-white/20 py-2 px-4">
                                <p class="text-gray-200 text-xs p-0 m-0">Total Proccesed Payments</p>
                                <p class="text-white text-xs p-0 m-0">{{ mostRecentDailyCronData()?.total_payments ??
                                    '-' }}
                                </p>
                            </div>
                        </div>

                        <!-- CONTENT -->
                        <div class="mb-6 flex-1 flex flex-col">
                            <div [ngClass]="getSmThreeCol('gap-3 sm:gap-4 mb-4')">
                                <div class="bg-green-500/20 border border-green-500/30 rounded-lg p-2">
                                    <div class="flex items-center justify-between mb-2">
                                        <div class="flex items-center gap-1 text-xs">
                                            <span class="text-green-400">
                                                <app-icon name="circleCheckBig" [size]="14"></app-icon>
                                            </span>
                                            <span class="text-green-400">Successful</span>
                                        </div>
                                        @if ($safeNavigationMigration(mostRecentPercentageStats()?.dailyCron?.successRate) !== null) {
                                        <div class="flex items-center gap-1">
                                            <div class="flex items-center gap-1 text-green-400 text-xs">
                                                <app-icon name="trendingUp" [size]="12"></app-icon>
                                                <p>{{mostRecentPercentageStats()?.dailyCron?.successRate}}%</p>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    <p class="text-white mb-1 text-xs">{{ (mostRecentDailyCronData()?.success_payments
                                        ?? 0)
                                        +
                                        (mostRecentDailyCronData()?.success_ach_payments ?? 0) }} payments
                                    </p>
                                    <p class="text-green-400 text-md">{{
                                        ((mostRecentDailyCronData()?.success_payments_amount ?? 0)
                                        + (mostRecentDailyCronData()?.success_ach_payments_amount ?? 0)) |
                                        currency }}</p>
                                </div>
                                <div class="bg-red-500/20 border border-red-500/30 rounded-lg p-2">
                                    <div class="flex items-center justify-between mb-2">
                                        <div class="flex items-center gap-1 text-xs">
                                            <span class="text-red-400">
                                                <app-icon name="circleCheckBig" [size]="14"></app-icon>
                                            </span>
                                            <span class="text-red-400">Failed</span>
                                        </div>
                                        @if ($safeNavigationMigration(mostRecentPercentageStats()?.dailyCron?.failedRate) !== null) {
                                        <div class="flex items-center gap-1">
                                            <div class="flex items-center gap-1 text-red-400 text-xs">
                                                <app-icon name="trendingDown" [size]="12"></app-icon>
                                                <p>{{mostRecentPercentageStats()?.dailyCron?.failedRate}}%</p>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    <p class="text-white mb-1 text-xs">{{ (mostRecentDailyCronData()?.failed_payments ??
                                        0)
                                        +
                                        (mostRecentDailyCronData()?.failed_ach_payments ?? 0) }} payments</p>
                                    <p class="text-red-400 text-md">{{
                                        ((mostRecentDailyCronData()?.failed_payments_amount
                                        ?? 0) +
                                        (mostRecentDailyCronData()?.failed_ach_payments_amount ?? 0)) |
                                        currency }}</p>
                                </div>
                                <div class="bg-amber-500/20 border border-amber-500/30 rounded-lg p-2">
                                    <div class="flex items-center justify-between mb-2">
                                        <div class="flex items-center gap-1 text-xs">
                                            <span class="text-amber-400">
                                                <app-icon name="clock" [size]="14"></app-icon>
                                            </span>
                                            <span class="text-amber-400">Pending</span>
                                        </div>
                                        @if ($safeNavigationMigration(mostRecentPercentageStats()?.dailyCron?.pendingRate) !== null) {
                                        <div class="flex items-center gap-1">
                                            <div class="flex items-center gap-1 text-amber-400 text-xs">
                                                <app-icon name="clock" [size]="12"></app-icon>
                                                <p>{{mostRecentDailyCronData()?.pending_ach_payments}}%</p>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    <p class="text-white mb-1 text-xs">{{
                                        mostRecentDailyCronData()?.pending_ach_payments }}
                                        payments</p>
                                    <p class="text-amber-400 text-md">{{
                                        (mostRecentDailyCronData()?.pending_ach_payments_amount ??
                                        0) |
                                        currency }}</p>
                                </div>
                            </div>

                            <div [ngClass]="getSmTwoCol('gap-3 sm:gap-4')">
                                <div class="bg-slate-800/50 border border-slate-700 rounded-lg p-2">
                                    <div class="flex items-center gap-1 mb-3 text-xs">
                                        <app-icon name="creditCard" [class]="'text-blue-400'" [size]="16"></app-icon>
                                        <span class="text-slate-200">Card Payments</span>
                                    </div>
                                    <div class="space-y-2 text-xs">
                                        <div class="flex justify-between">
                                            <span class="text-slate-300">Total</span>
                                            <span class="text-white">{{ mostRecentDailyCronData()?.card_payments ?? '-'
                                                }}</span>
                                        </div>
                                        <div class="flex justify-between">
                                            <span class="text-green-400">Successful</span>
                                            <span class="text-white">{{ mostRecentDailyCronData()?.success_card_payments
                                                ??
                                                '-' }}
                                                ({{mostRecentDailyCronData()?.success_payments_amount ?? 0 |
                                                currency}})</span>
                                        </div>
                                        <div class="flex justify-between">
                                            <span class="text-red-400">Failed</span>
                                            <span class="text-white">{{ mostRecentDailyCronData()?.failed_card_payments
                                                ??
                                                '-' }}
                                                ({{mostRecentDailyCronData()?.failed_payments_amount ?? 0 |
                                                currency}})</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="bg-slate-800/50 border border-slate-700 rounded-lg p-2">
                                    <div class="flex items-center gap-1 mb-3 text-xs">
                                        <app-icon name="wallet" [class]="'text-purple-400'" [size]="16"></app-icon>
                                        <span class="text-slate-200">Bank Payments</span>
                                    </div>
                                    <div class="space-y-2 text-xs">
                                        <div class="flex justify-between">
                                            <span class="text-slate-300">Total</span>
                                            <span class="text-white">{{ mostRecentDailyCronData()?.ach_payments ?? '-'
                                                }}</span>
                                        </div>
                                        <div class="flex justify-between">
                                            <span class="text-green-400">Successful</span>
                                            <span class="text-white">{{ mostRecentDailyCronData()?.success_ach_payments
                                                ??
                                                '-' }}
                                                ({{mostRecentDailyCronData()?.success_ach_payments_amount ?? 0 |
                                                currency}})</span>
                                        </div>
                                        <div class="flex justify-between">
                                            <span class="text-red-400">Failed</span>
                                            <span class="text-white">{{ mostRecentDailyCronData()?.failed_ach_payments
                                                ??
                                                '-' }}
                                                ({{mostRecentDailyCronData()?.failed_ach_payments_amount ?? 0 |
                                                currency}})</span>
                                        </div>
                                        <div class="flex justify-between">
                                            <span class="text-amber-400">Pending</span>
                                            <span class="text-white">{{ mostRecentDailyCronData()?.pending_ach_payments
                                                ??
                                                '-' }}
                                                ({{mostRecentDailyCronData()?.pending_ach_payments_amount ?? 0 |
                                                currency}})</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                }

                @case (SectionId.TRY_AGAIN_OVERVIEW) {
                <div class="flex flex-col gap-4 h-full">
                    <div
                        class="relative w-full flex-1 bg-gradient-to-br from-slate-900 to-slate-800 rounded-lg shadow-lg border border-white/10 p-4 overflow-hidden group flex flex-col">
                        @if(isLoadingMostRecentDailyCron()) {
                        <div
                            class="absolute inset-0 z-50 flex items-center justify-center bg-slate-900/80 backdrop-blur-sm rounded-lg">
                            <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
                        </div>
                        }
                        <!-- CIRCLES AND BACKGROUND EFFECTS -->
                        <div
                            class="absolute inset-0 bg-gradient-to-tr from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                        </div>
                        <div
                            class="absolute -top-24 -right-24 w-64 h-64 bg-blue-500 rounded-full blur-3xl opacity-20 group-hover:opacity-30 transition-opacity duration-500">
                        </div>
                        <div
                            class="absolute -bottom-24 -left-24 w-64 h-64 bg-blue-500 rounded-full blur-3xl opacity-10 group-hover:opacity-20 transition-opacity duration-500">
                        </div>

                        <!-- HEADER -->
                        <div class="relative z-10 flex items-center justify-between mb-6">
                            <div class="flex items-center gap-3">
                                <div
                                    class="bg-white/10 backdrop-blur-xl p-2 rounded-lg border border-white/20 shadow-lg text-blue-400">
                                    <app-icon name="zap" class="text-white" [size]="16"></app-icon>
                                </div>
                                <div>
                                    <h3 class="text-white text-md font-black">Try Again Cron Last Attempt</h3>
                                    <p class="text-white/60 text-xs p-0 m-0">Automated Payment Processing of Failed
                                        Payments
                                    </p>
                                </div>
                            </div>

                            <div
                                class="flex items-center gap-2 rounded-lg bg-white/10 backdrop-blur-xl font-medium border border-white/20 py-2 px-4">
                                <p class="text-gray-200 text-xs p-0 m-0">Total Proccesed Payments</p>
                                <p class="text-white text-xs p-0 m-0">{{
                                    mostRecentDailyCronData()?.try_again_payments_from_cron ??
                                    '-' }}
                                </p>
                            </div>
                        </div>

                        <!-- CONTENT -->
                        <div class="mb-6 flex-1">
                            <div [ngClass]="getSmTwoCol('gap-3 sm:gap-4 mb-4')">
                                <div class="bg-green-500/20 border border-green-500/30 rounded-lg p-2">
                                    <div class="flex items-center justify-between mb-2">
                                        <div class="flex items-center gap-1 text-xs">
                                            <span class="text-green-400">
                                                <app-icon name="circleCheckBig" [size]="14"></app-icon>
                                            </span>
                                            <span class="text-green-400">Successful</span>
                                        </div>
                                        @if ($safeNavigationMigration(mostRecentPercentageStats()?.tryAgainCron?.successRate) !== null) {
                                        <div class="flex items-center gap-1">
                                            <div class="flex items-center gap-1 text-green-400 text-xs">
                                                <app-icon name="trendingUp" [size]="12"></app-icon>
                                                <p>{{mostRecentPercentageStats()?.tryAgainCron?.successRate}}%</p>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    <p class="text-white mb-1 text-xs">{{
                                        (mostRecentDailyCronData()?.try_again_payments_success ??
                                        0) }} payments
                                    </p>
                                    <p class="text-green-400 text-md">{{
                                        (mostRecentDailyCronData()?.try_again_payments_success_amount ?? 0) | currency
                                        }}
                                    </p>
                                </div>
                                <div class="bg-red-500/20 border border-red-500/30 rounded-lg p-2">
                                    <div class="flex items-center justify-between mb-2">
                                        <div class="flex items-center gap-1 text-xs">
                                            <span class="text-red-400">
                                                <app-icon name="circleCheckBig" [size]="14"></app-icon>
                                            </span>
                                            <span class="text-red-400">Failed</span>
                                        </div>
                                        @if ($safeNavigationMigration(mostRecentPercentageStats()?.tryAgainCron?.failedRate) !== null) {
                                        <div class="flex items-center gap-1">
                                            <div class="flex items-center gap-1 text-red-400 text-xs">
                                                <app-icon name="trendingDown" [size]="12"></app-icon>
                                                <p>{{mostRecentPercentageStats()?.tryAgainCron?.failedRate}}%</p>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    <p class="text-white mb-1 text-xs">{{
                                        mostRecentDailyCronData()?.try_again_payments_failed ?? 0
                                        }}
                                        payments</p>
                                    <p class="text-red-400 text-md">{{
                                        mostRecentDailyCronData()?.try_again_payments_failed_amount
                                        ?? 0 |
                                        currency }}</p>
                                </div>
                            </div>

                            <div class="grid grid-cols-1 gap-4">
                                <div class="bg-slate-800/50 border border-slate-700 rounded-lg p-2">
                                    <div class="flex items-center gap-1 mb-3 text-xs">
                                        <app-icon name="walletCards" [class]="'text-blue-400'" [size]="16"></app-icon>
                                        <span class="text-slate-200">Payments Overview</span>
                                    </div>
                                    <div class="space-y-2 text-xs">
                                        <div class="flex justify-between">
                                            <span class="text-slate-300">Total Recommended</span>
                                            <span class="text-white">{{
                                                mostRecentDailyCronData()?.try_again_payments_recommended ??
                                                '-' }}</span>
                                        </div>
                                        <div class="flex justify-between">
                                            <span class="text-slate-300">Total Attempted</span>
                                            <span class="text-white">{{
                                                mostRecentDailyCronData()?.try_again_payments_from_cron ??
                                                '-' }}</span>
                                        </div>
                                        <div class="flex justify-between">
                                            <span class="text-green-400">Successful</span>
                                            <span class="text-white">{{
                                                mostRecentDailyCronData()?.try_again_payments_success ?? '-'
                                                }}
                                                ({{mostRecentDailyCronData()?.success_payments_amount ?? 0 |
                                                currency}})</span>
                                        </div>
                                        <div class="flex justify-between">
                                            <span class="text-red-400">Failed</span>
                                            <span class="text-white">{{
                                                mostRecentDailyCronData()?.try_again_payments_failed
                                                ?? '-'
                                                }}
                                                ({{mostRecentDailyCronData()?.failed_payments_amount ?? 0 |
                                                currency}})</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }

                @case (SectionId.PAYMENT_LIFECYCLE) {
                <!-- Yearly Milestone Timeline Section -->
                <div class="animate-fadeIn">
                    <div class="w-full min-h-[400px] md:min-h-[400px] relative">
                        @if(isLoadingDailyCronOverview()) {
                        <div
                            class="absolute inset-0 z-10 flex items-center justify-center bg-white/60 dark:bg-surface-1/60 backdrop-blur-sm rounded-xl">
                            <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
                        </div>
                        }
                        <app-timeline-chart [data]="yearlyTimelineData()" [config]="{
                    title: 'Cron Payment Lifecycle',
                    subtitle: 'Yearly milestones & evolution:',
                    themeColor: '#3b82f6',
                    animate: true
                }" [filters]="[
                    { label: 'All Stats', options: ['Key Milestones', 'Secondary Events'] },
                    { label: 'View Type', options: ['Yearly View', 'Quarterly View'] }
                ]" [sidebarData]="yearlyTimelineSidebarData()">
                        </app-timeline-chart>
                    </div>
                </div>
                }

                }
            </div>
            }
        </div>

        <!-- Chart Time Unit Selector — kept as a static control row between the
     overview grid and the analytics grid. The date picker drives every
     section in the analytics grid (metric cards, trend charts, funnels,
     PF status events) so it stays visually anchored at the top of that
     group rather than being part of the customizable layout. -->
        @if (!mixedMode()) {
        <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 my-6 md:my-8">
            <div>
                <h3 class="text-lg sm:text-xl font-medium text-[#141437] dark:text-white backdrop-blur-sm">Payment
                    Analytics
                </h3>
            </div>

            <!-- Refresh Button, Date Picker and Unit Indicator -->
            <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
                <app-date-picker [showComparison]="false" [showGroupBy]="true"
                    [value]="{ startDate: selectedStartDate(), endDate: selectedEndDate(), unit: selectedUnit(), comparisonType: 'none' }"
                    [allowedGroupByUnits]="['day','week','month','quarter','year']"
                    [alwaysAvailableUnit]="alwaysAvailableUnits()" (dateRangeChange)="onDateRangeChange($event)">
                </app-date-picker>

                <button type="button"
                    class="flex items-center justify-between px-4 py-3 rounded-lg transition-all duration-300 group bg-white dark:bg-surface-1 text-[#141437] dark:text-white hover:border-purple-400 dark:hover:border-line-strong hover:bg-white dark:hover:bg-surface-1/50 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 dark:focus:border-purple-400 gap-2 border border-purple-500/20 backdrop-blur-sm"
                    aria-label="Refresh Data">
                    <app-icon name="refreshCcw" [size]="16" [class]="'text-slate-600 dark:text-slate-300'"></app-icon>
                    <span class="text-sm font-medium text-slate-700 dark:text-slate-200">Refresh</span>
                </button>
            </div>
        </div>
        }

        <!-- ─────────────────────────────────────────────────────────────────────────
 
     ANALYTICS Customizable Grid
     Customizable 12-col grid wrapping every date-range driven section
     (metric cards, trend charts, funnels, PF status events). Defaults
     reproduce the original visual layout (metric cards full-width,
     volume/amount charts at 6/6, success-trend + daily-cron-funnel at
     8/4, try-again-funnel + retry-combo at 4/8, PF status events
     full-width).
─────────────────────────────────────────────────────────────────────────── -->
        <div class="grid grid-cols-12 gap-4 md:gap-6 grid-flow-row-dense mt-6">
            @for (sec of analyticsSections(); track trackSection($index, sec)) {
            <div [ngClass]="getSectionColClass(sec)" class="group relative">

                @if (!mixedMode() && canPinToCustomDashboard(sec)) {
                <button type="button" (click)="addToCustomDashboard(sec); $event.stopPropagation()"
                    [disabled]="isAddingToCustomDashboard(sec)"
                    class="group/pin absolute cursor-pointer top-2 right-2 z-20 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                    [ngClass]="isAddedToCustomDashboard(sec)
            ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
            : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                    [attr.aria-label]="isAddedToCustomDashboard(sec) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                    [title]="isAddedToCustomDashboard(sec) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                    @if (isAddingToCustomDashboard(sec)) {
                    <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                    </svg>
                    <span>{{ isAddedToCustomDashboard(sec) ? 'Removing' : 'Adding' }}&hellip;</span>
                    } @else if (isAddedToCustomDashboard(sec)) {
                    <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                        height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                        height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path d="M5 12h14" />
                    </svg>
                    <span
                        class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                        from Custom Dashboard</span>
                    } @else {
                    <!-- Not-pinned state: pill is hidden at card-rest (opacity-0).
             On card hover it fades in as a compact "+" icon only.
             Hovering the icon itself then morphs the pill open
             (max-width animates) to reveal the full "Pin to Custom
             Dashboard" label. The negative margin on the label
             collapses the flex gap when the label is closed so the
             at-rest icon stays visually centred in a small circle. -->
                    <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M5 12h14" />
                        <path d="M12 5v14" />
                    </svg>
                    <span
                        class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                        to Custom Dashboard</span>
                    }
                </button>
                }

                @switch (sec.id) {

                @case (SectionId.PAYMENT_ANALYTICS_STATS) {
                <div [ngClass]="getMetricCardsGrid('gap-4 md:gap-6 relative')">
                    @if(isLoadingDailyCronData()) {
                    <div
                        class="absolute inset-0 z-10 flex items-center justify-center bg-white/60 dark:bg-surface-1/60 backdrop-blur-sm rounded-xl">
                        <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
                    </div>
                    }
                    @for (metric of metricCards(); track metric.title) {
                    <div class="rounded-xl shadow-sm border p-4 hover:shadow-md transition-shadow backdrop-blur-md h-full flex flex-col"
                        [ngClass]="[getBorderClass(metric.color), getBgClass(metric.bg_color)]">
                        <div class="flex items-start justify-between flex-1">
                            <div class="flex-1">
                                <p class="text-slate-700 dark:text-slate-300 mb-2 text-md">{{ metric.title }}</p>
                                <p class="text-slate-800 dark:text-white mb-1 text-md font-medium">{{ metric.value }}
                                </p>
                                @if (metric.subtitle) {
                                <p class="text-slate-500 dark:text-slate-400 text-sm mt-1">{{ metric.subtitle }}</p>
                                }
                            </div>
                            <div class="ml-4 flex-shrink-0"
                                [ngClass]="getBgClass(metric.color) + ' ' + getIconClass(metric.color)"
                                [class]="'p-3 rounded-lg'">
                                <app-icon [name]="metric.icon" [size]="20"></app-icon>
                            </div>
                        </div>
                    </div>
                    }

                    @for (metric of retryMetricCards(); track metric.title) {
                    <div class="rounded-xl shadow-sm border border-white/10 p-4 hover:shadow-md transition-shadow backdrop-blur-md text-white h-full flex flex-col"
                        [ngClass]="getRetryBgClass(metric.color)">
                        <div class="flex items-center gap-3 mb-2">
                            <div class="bg-white/20 p-2 rounded-lg flex-shrink-0">
                                <app-icon [name]="metric.icon" [size]="20"></app-icon>
                            </div>
                            <span class="text-md">{{ metric.title }}</span>
                        </div>
                        <p class="text-white mb-1 text-md font-medium">{{ metric.value }}</p>
                        <p class="text-white/80 text-sm mt-1">{{ metric.subtitle }}</p>
                    </div>
                    }
                </div>
                }

                @case (SectionId.VOLUME_TRENDS) {
                <!-- Payment Volume Trends Chart -->
                <div class="relative w-full h-[350px] sm:h-[380px] md:h-[400px] lg:h-[380px]">
                    @if(isLoadingDailyCronData()) {
                    <div
                        class="absolute inset-0 z-20 flex items-center justify-center bg-white/60 dark:bg-surface-1/60 backdrop-blur-sm rounded-xl">
                        <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
                    </div>
                    }
                    <!-- Cron Type Tab Switch - Using Common Component -->
                    <div class="absolute top-3 right-3 z-10">
                        <app-toggle-btns [headerOptions]="{ 
                    showlabels: true, 
                    showIcon: false, 
                    showToggleButton: true, 
                    toggleOptions: volumeToggleOptions, 
                    showTable: selectedVolumeCronType() === 'tryAgain',
                    size: 'sm',
                    activeTextColor: '#3b82f6',
                }" (viewChanged)="onVolumeToggleChange($event)" [auditContext]="'Total Volume Comparison'">
                        </app-toggle-btns>
                    </div>
                    <app-line-area-chart [series]="paymentVolumeSeries()" [title]="paymentVolumeChartTitle()"
                        [titleClass]="'text-slate-700 dark:text-white'" [showCard]="true" [cardClass]="'card-bg'"
                        [curveType]="'monotoneX'" [useGradientFill]="true" [animate]="true" [dateUnit]="selectedUnit()"
                        [xAxis]="chartXAxisConfig()"
                        [yAxis]="{ show: true, showGrid: true, gridStyle: 'dashed', showAxisLine: false, tickCount: 5 }"
                        [legend]="{ show: true, position: 'bottom', align: 'center', itemGap: 32 }"
                        [tooltip]="{ show: true, showHoverLine: true, valueFormat: 'number' }"
                        [margins]="{ top: 20, right: 20, bottom: 40, left: 50 }">
                    </app-line-area-chart>
                </div>
                }

                @case (SectionId.AMOUNT_TRENDS) {
                <!-- Payment Amount Trends Chart -->
                <div class="relative w-full h-[350px] sm:h-[380px] md:h-[400px] lg:h-[380px]">
                    @if(isLoadingDailyCronData()) {
                    <div
                        class="absolute inset-0 z-20 flex items-center justify-center bg-white/60 dark:bg-surface-1/60 backdrop-blur-sm rounded-xl">
                        <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
                    </div>
                    }
                    <!-- Cron Type Tab Switch - Using Common Component -->
                    <div class="absolute top-3 right-3 z-10">
                        <app-toggle-btns [headerOptions]="{ 
                    showlabels: true, 
                    showIcon: false, 
                    showToggleButton: true, 
                    toggleOptions: amountToggleOptions, 
                    showTable: selectedAmountCronType() === 'tryAgain',
                    size: 'sm',
                    activeTextColor: '#3b82f6',
                }" (viewChanged)="onAmountToggleChange($event)" [auditContext]="'Total Amount Comparison'">
                        </app-toggle-btns>
                    </div>
                    <app-line-area-chart [series]="paymentAmountSeries()" [title]="paymentAmountChartTitle()"
                        [titleClass]="'text-slate-700 dark:text-white'" [showCard]="true" [cardClass]="'card-bg'"
                        [curveType]="'monotoneX'" [useGradientFill]="true" [animate]="true" [dateUnit]="selectedUnit()"
                        [xAxis]="chartXAxisConfig()"
                        [yAxis]="{ show: true, showGrid: true, gridStyle: 'dashed', showAxisLine: false, tickCount: 5 }"
                        [legend]="{ show: true, position: 'bottom', align: 'center', itemGap: 32 }"
                        [tooltip]="{ show: true, showHoverLine: true, valueFormat: 'currency' }"
                        [margins]="{ top: 20, right: 20, bottom: 40, left: 60 }">
                    </app-line-area-chart>
                </div>
                }

                @case (SectionId.SUCCESS_RATE_TREND) {
                <!-- Success Payment Trend Chart -->
                <div
                    class="relative w-full min-w-0 h-[350px] sm:h-[380px] md:h-[400px] lg:h-full flex overflow-visible animate-fadeIn">
                    @if(isLoadingDailyCronData()) {
                    <div
                        class="absolute inset-0 z-20 flex items-center justify-center bg-white/60 dark:bg-surface-1/60 backdrop-blur-sm rounded-xl">
                        <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
                    </div>
                    }
                    <!-- Cron Type Tab Switch - Using Common Component -->
                    <div class="absolute top-3 right-3 z-10">
                        <app-toggle-btns [headerOptions]="{ 
                    showlabels: true, 
                    showIcon: false, 
                    showToggleButton: true, 
                    toggleOptions: successPaymentTrendToggleOptions, 
                    showTable: selectedSuccessPaymentTrendCronType() === 'tryAgain',
                    size: 'sm',
                    activeTextColor: '#3b82f6',
                }" (viewChanged)="onSuccessPaymentTrendToggleChange($event)" [auditContext]="'Success Payment Trend'">
                        </app-toggle-btns>
                    </div>
                    <app-comprehensive-bar-chart [series]="successPaymentTrendSeries()" [mode]="'combo'"
                        [orientation]="'vertical'" [barWidth]="0.6"
                        [animation]="{ enabled: true, duration: 750, easing: 'easeOut' }" [barRadius]="4"
                        [title]="'Success Payment Trend'" [titleClass]="'text-slate-700 dark:text-white'"
                        [showCard]="true" [cardClass]="'card-bg'"
                        [xAxis]="{ show: true, showGrid: false, showAxisLine: true, showOnlyFirstLast: true, fontSize: 12 }"
                        [yAxis]="{ show: true, showGrid: false, showAxisLine: false, tickCount: 5, fontSize: 12 }"
                        [yAxisRight]="{ show: true, showGrid: false, showAxisLine: false, tickCount: 5, fontSize: 12 }"
                        [legend]="{ show: true, position: 'bottom', align: 'center', itemGap: 32 }"
                        [tooltip]="{ show: true, showHoverLine: true, valueFormat: 'currency', showTotal: false }"
                        [margins]="{ top: 20, right: 60, bottom: 40, left: 60 }" [height]="270">
                    </app-comprehensive-bar-chart>
                </div>
                }

                @case (SectionId.EFFICIENCY) {
                <!-- Daily Cron Funnel -->
                <div class="w-full min-w-0 overflow-visible relative animate-fadeIn">
                    @if(isLoadingDailyCronData()) {
                    <div
                        class="absolute inset-0 z-10 flex items-center justify-center bg-white/60 dark:bg-surface-1/60 backdrop-blur-sm rounded-xl">
                        <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
                    </div>
                    }
                    <app-funnel-chart [data]="dailyCronFunnelData()" [config]="{
            title: 'Daily Cron Efficiency',
            subtitle: 'Payment lifecycle conversion',
            animate: false
        }"></app-funnel-chart>
                </div>
                }

                @case (SectionId.RETRY_STRATEGY_IMPACT) {
                <!-- TryAgain Cron Funnel -->
                <div
                    class="w-full min-w-0 h-[350px] sm:h-[380px] md:h-[400px] lg:h-full flex min-h-[350px] overflow-visible relative animate-fadeIn">
                    @if(isLoadingDailyCronData()) {
                    <div
                        class="absolute inset-0 z-10 flex items-center justify-center bg-white/60 dark:bg-surface-1/60 backdrop-blur-sm rounded-xl">
                        <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
                    </div>
                    }
                    <app-funnel-chart [data]="tryAgainFunnelData()" [config]="{
                title: 'Retry Strategy Impact',
                subtitle: 'TryAgain cron performance',
                animate: false
            }"></app-funnel-chart>
                </div>
                }

                @case (SectionId.RETRY_STRATEGY_TRENDS) {
                <!-- Retry Cron Combo Chart (Bars + Line) -->
                <div
                    class="relative w-full min-w-0 h-[350px] sm:h-[380px] md:h-[400px] lg:h-full flex min-h-[350px] overflow-visible animate-fadeIn">
                    @if(isLoadingDailyCronData()) {
                    <div
                        class="absolute inset-0 z-20 flex items-center justify-center bg-white/60 dark:bg-surface-1/60 backdrop-blur-sm rounded-xl">
                        <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
                    </div>
                    }
                    <app-comprehensive-bar-chart [series]="retryCronComboChartSeries()" [mode]="'combo'"
                        [orientation]="'vertical'" [barWidth]="0.55"
                        [animation]="{ enabled: true, duration: 750, easing: 'easeOut' }" [barRadius]="4"
                        [title]="'Retry Strategy Trends'" [titleClass]="'text-slate-700 dark:text-white'"
                        [showCard]="true" [cardClass]="'card-bg'"
                        [xAxis]="{ show: true, showGrid: false, showAxisLine: true, showOnlyFirstLast: true, fontSize: 12 }"
                        [yAxis]="{ show: true, showGrid: false, gridStyle: 'dashed', showAxisLine: false, tickCount: 5, fontSize: 12 }"
                        [yAxisRight]="{ show: true, showGrid: false, showAxisLine: false, tickCount: 5, fontSize: 12 }"
                        [legend]="{ show: true, position: 'bottom', align: 'center', itemGap: 32 }"
                        [tooltip]="{ show: true, showHoverLine: true, valueFormat: 'number', showTotal: false }"
                        [margins]="{ top: 20, right: 60, bottom: 40, left: 60 }" [height]="270">
                    </app-comprehensive-bar-chart>
                </div>
                }

                @case (SectionId.CONTRACT_STATE_EVENTS) {
                <!-- PF Status Event Analytics Section -->
                <div class="rounded-xl border border-slate-200/80 dark:border-slate-700/60
         bg-white/90 dark:bg-surface-1/90
         backdrop-blur-xl
         shadow-sm hover:shadow-md transition-shadow
         p-4 sm:p-5">

                    <!-- Header + Metrics -->
                    <div class="flex items-center justify-between">
                        <div class="flex items-start gap-3">
                            <div class="flex h-10 w-10 items-center justify-center
                  rounded-lg
                  bg-indigo-50 dark:bg-indigo-500/20
                  border border-indigo-200 dark:border-indigo-500/30">
                                <app-icon name="trendingUp" class="text-indigo-600 dark:text-indigo-400" [size]="22">
                                </app-icon>
                            </div>

                            <div class="flex flex-col gap-0.5">
                                <h3
                                    class="text-lg sm:text-xl font-medium text-[#141437] dark:text-white backdrop-blur-sm">
                                    Contract State Events
                                </h3>
                                <p class="text-xs sm:text-sm text-slate-600 dark:text-slate-400 leading-snug">
                                    Monitor contract status transitions and analyze trends over time
                                </p>
                            </div>
                        </div>
                        <!-- KPIs -->
                        <div class="flex flex-wrap gap-3 justify-start lg:justify-end">

                            <!-- Total -->
                            <div class="flex items-center gap-3
               min-w-[150px]
               rounded-lg
               border border-blue-200 dark:border-blue-500/30
               bg-blue-50/80 dark:bg-blue-500/15
               px-3 py-2">
                                <div class="rounded-md bg-blue-100 dark:bg-blue-500/20 p-1.5">
                                    <app-icon name="fileText" class="text-blue-600 dark:text-blue-400" [size]="16">
                                    </app-icon>
                                </div>

                                <div class="leading-tight">
                                    <p class="text-xs text-slate-600 dark:text-slate-400">Total</p>
                                    <p class="text-base sm:text-lg font-semibold text-blue-700 dark:text-blue-300">
                                        {{ formatNumber(pfStatusEventStats().totalContracts) }}
                                    </p>
                                </div>
                            </div>

                            <!-- Average -->
                            <div class="flex items-center gap-3
               min-w-[150px]
               rounded-lg
               border border-green-200 dark:border-green-500/30
               bg-green-50/80 dark:bg-green-500/15
               px-3 py-2">
                                <div class="rounded-md bg-green-100 dark:bg-green-500/20 p-1.5">
                                    <app-icon name="chartBar" class="text-green-600 dark:text-green-400" [size]="16">
                                    </app-icon>
                                </div>

                                <div class="leading-tight">
                                    <p class="text-xs text-slate-600 dark:text-slate-400">
                                        Avg • {{ formatNumber(pfStatusEventStats().periodCount) }}p
                                    </p>
                                    <p class="text-base sm:text-lg font-semibold text-green-700 dark:text-green-300">
                                        {{ formatNumber(pfStatusEventStats().roundedAverageContracts) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Filters -->
                    <div class="my-6 flex flex-col gap-4
           lg:flex-row lg:items-start lg:justify-between">
                        <!-- Filters -->
                        <div class="flex flex-col sm:flex-row gap-3 w-full lg:max-w-[420px]">
                            <app-dropdown class="w-full" [options]="oldPfStatusOptions()"
                                [selectedValue]="selectedOldPfStatus()" (selectionChange)="onOldPfStatusChange($event)"
                                [placeholder]="'From Status'" [size]="'sm'" [variant]="'default'" [fullWidth]="true">
                            </app-dropdown>

                            <app-dropdown class="w-full" [options]="newPfStatusOptions()"
                                [selectedValue]="selectedNewPfStatus()" (selectionChange)="onNewPfStatusChange($event)"
                                [placeholder]="'To Status'" [size]="'sm'" [variant]="'default'" [fullWidth]="true">
                            </app-dropdown>
                        </div>


                    </div>

                    <!-- CHART AREA -->
                    <div class="min-h-[400px] grid grid-cols-1 relative overflow-visible">
                        @if(isLoadingPfStatusEvent()) {
                        <div
                            class="absolute inset-0 z-20 flex items-center justify-center bg-white/60 dark:bg-surface-1/60 backdrop-blur-sm rounded-xl">
                            <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
                        </div>
                        }
                        <div
                            class="absolute top-2 right-2 sm:top-3 sm:right-3 z-10 flex items-center gap-1.5 sm:gap-2 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm rounded-md px-2 sm:px-2.5 py-1 sm:py-1.5 border border-slate-200 dark:border-slate-700 shadow-sm">
                            <span
                                class="text-xs font-medium text-slate-600 dark:text-slate-400 whitespace-nowrap hidden sm:inline">Running
                                Total</span>
                            <span class="text-xs font-medium text-slate-600 dark:text-slate-400 sm:hidden">RT</span>
                            <app-toggle [checked]="showRunningTotal()" (toggleChange)="showRunningTotal.set($event)"
                                [auditContext]="'Running Total'" [className]="'scale-75 sm:scale-90'">
                            </app-toggle>
                        </div>
                        <app-line-area-chart [series]="pfStatusCombinedSeries()" [title]="pfStatusChartTitle()"
                            [titleClass]="'text-slate-700 dark:text-white'" [showCard]="true" [cardClass]="'card-bg'"
                            [curveType]="'monotoneX'" [useGradientFill]="true" [animate]="true"
                            [animationDuration]="800" [height]="450" [dateUnit]="selectedUnit()"
                            [xAxis]="chartXAxisConfig()"
                            [yAxis]="{ show: true, showGrid: true, gridStyle: 'dashed', showAxisLine: false, tickCount: 5 }"
                            [legend]="{ show: true, position: 'bottom', align: 'center', itemGap: 32 }"
                            [tooltip]="{ show: true, showHoverLine: true, valueFormat: 'number', showTotal: false }"
                            [margins]="{ top: 20, right: 10, bottom: 40, left: 20 }">
                        </app-line-area-chart>
                    </div>
                </div>
                }

                }
            </div>
            }
        </div>
    </div>

    <!-- custom layout of mini view of the dashboard -->
    @if (isLayoutEditorOpen()) {
    <div appLayoutEditorOverlay
        class="fixed inset-0 z-[10010] flex items-center justify-center p-3 sm:p-6 bg-slate-900/60 backdrop-blur-sm animate-fadeIn overflow-hidden"
        (click)="closeLayoutEditor()">

        <div class="layout-editor-popup relative w-full max-w-[1100px] max-h-[min(88vh,calc(100vh-2rem))] flex flex-col bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-700 overflow-hidden"
            (click)="$event.stopPropagation()">

            <!-- Header -->
            <div
                class="flex flex-wrap items-center justify-between gap-3 px-5 sm:px-6 py-4 border-b border-slate-200 dark:border-slate-700 bg-gradient-to-r from-[#AD46FF]/5 via-white to-[#AD46FF]/5 dark:from-purple-500/10 dark:via-slate-900 dark:to-purple-500/10">
                <div class="flex items-center gap-3 min-w-0">
                    <div
                        class="w-10 h-10 rounded-xl bg-gradient-to-br from-[#AD46FF] to-[#7c3aed] flex items-center justify-center shadow-lg shadow-[#AD46FF]/30 shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                            <rect width="7" height="9" x="3" y="3" rx="1" />
                            <rect width="7" height="5" x="14" y="3" rx="1" />
                            <rect width="7" height="9" x="14" y="12" rx="1" />
                            <rect width="7" height="5" x="3" y="16" rx="1" />
                        </svg>
                    </div>
                    <div class="min-w-0">
                        <h2 class="text-lg sm:text-xl font-semibold text-[#141437] dark:text-white truncate">
                            Customize Layout
                        </h2>
                        <p class="text-[11px] text-violet-700 dark:text-violet-300">
                            <b>Drag</b> a card to reorder &middot; click the <b>width chips</b> to resize &middot;
                            toggle
                            the <b>eye</b> to hide/show &middot; the preview mirrors the real dashboard.
                        </p>
                    </div>
                </div>

                <div class="flex items-center gap-2.5 flex-wrap">
                    <!-- Auto Adjust Width -->
                    <button type="button" (click)="autoAdjustEditorWidths()" [disabled]="!canAutoAdjustEditorWidths()"
                        class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all"
                        [ngClass]="canAutoAdjustEditorWidths()
                        ? 'bg-white dark:bg-slate-800 text-[#AD46FF] border border-[#AD46FF]/30 hover:bg-violet-50 dark:hover:bg-white/5 hover:border-[#AD46FF]/60 shadow-sm cursor-pointer'
                        : 'bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 border border-slate-200 dark:border-slate-700 cursor-not-allowed'"
                        title="Expand the smallest card in each row to fill the leftover columns">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="15 3 21 3 21 9" />
                            <polyline points="9 21 3 21 3 15" />
                            <line x1="21" y1="3" x2="14" y2="10" />
                            <line x1="3" y1="21" x2="10" y2="14" />
                        </svg>
                        Auto Adjust Width
                    </button>

                    <!-- Visible count chip -->
                    <span
                        class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-violet-50 dark:bg-violet-500/10 text-[#AD46FF] border border-[#AD46FF]/20">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                            <circle cx="12" cy="12" r="3" />
                        </svg>
                        {{ editorVisibleCount() }} / {{ editorItems().length }} visible
                    </span>

                    <!-- Close -->
                    <button type="button" (click)="closeLayoutEditor()"
                        class="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                        title="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M18 6 6 18" />
                            <path d="m6 6 12 12" />
                        </svg>
                    </button>
                </div>
            </div>

            <!-- Layout Preview Area (mini dashboard editor) -->
            <div class="flex-1 overflow-y-auto custom-scroll bg-[#FAFAFE] dark:bg-slate-950/40 p-3 sm:p-4">

                @for (group of editorGroups(); track $index) {
                <div cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="onGroupEditorCardDrop($index, $event)"
                    class="grid grid-cols-12 gap-2 sm:gap-2.5 grid-flow-row-dense" [class.mt-6]="$index === 1">

                    @for (item of group; track trackEditorItem($index, item)) {
                    <div cdkDrag cdkDragBoundary=".layout-editor-popup" [cdkDragData]="item" [cdkDragDisabled]="!item.visible" [ngClass]="[
                        getEditorColSpanClass(item.colSpan),
                        item.visible
                            ? 'border-slate-200 dark:border-slate-700 shadow-sm hover:shadow-lg hover:-translate-y-0.5 hover:border-[#AD46FF]/40 cursor-grab active:cursor-grabbing'
                            : 'border-dashed border-slate-300 dark:border-slate-600 opacity-60 cursor-not-allowed'
                    ]"
                        class="layout-editor-tile group relative rounded-xl border bg-white dark:bg-slate-800 transition-all duration-200 overflow-hidden">

                        <!-- Drop placeholder -->
                        <div *cdkDragPlaceholder [ngClass]="getEditorColSpanClass(item.colSpan)"
                            class="rounded-xl border-2 border-dashed border-[#AD46FF]/60 bg-violet-50 dark:bg-violet-500/10 min-h-[88px]">
                        </div>

                        <!-- Tile header: drag handle + title + visibility toggle -->
                        <div class="flex items-start justify-between gap-2 px-2.5 pt-2 pb-1">
                            <div class="flex items-center gap-1.5 min-w-0">
                                <span
                                    class="text-slate-300 dark:text-slate-600 group-hover:text-[#AD46FF] transition-colors shrink-0"
                                    title="Drag to reorder">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                        fill="currentColor" stroke="none">
                                        <circle cx="9" cy="5" r="1" />
                                        <circle cx="9" cy="12" r="1" />
                                        <circle cx="9" cy="19" r="1" />
                                        <circle cx="15" cy="5" r="1" />
                                        <circle cx="15" cy="12" r="1" />
                                        <circle cx="15" cy="19" r="1" />
                                    </svg>
                                </span>
                                <span
                                    class="text-[11px] sm:text-[12px] font-semibold text-[#141437] dark:text-white truncate"
                                    [title]="item.title">
                                    {{ item.title }}
                                </span>
                            </div>

                            <!-- Visibility toggle -->
                            <button type="button"
                                (click)="toggleEditorCardVisibility(item.id); $event.stopPropagation()"
                                class="p-1 rounded-md transition-colors shrink-0"
                                [ngClass]="item.visible
                                ? 'text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                                : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700'"
                                [title]="item.visible ? 'Hide section' : 'Show section'">
                                @if (item.visible) {
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                                    <circle cx="12" cy="12" r="3" />
                                </svg>
                                } @else {
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
                                    <path
                                        d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
                                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                                    <line x1="2" y1="2" x2="22" y2="22" />
                                </svg>
                                }
                            </button>
                        </div>

                        <!-- Tile body: scaled-down preview placeholder + width chips. -->
                        <div class="px-2.5 pb-2">
                            <div
                                class="rounded-lg bg-gradient-to-br from-violet-50 via-white to-violet-50/50 dark:from-violet-500/10 dark:via-slate-800 dark:to-violet-500/5 border border-slate-100 dark:border-slate-700/50 h-10 sm:h-10 flex items-center justify-center mb-1.5 overflow-hidden relative">
                                <div class="flex items-end gap-1 w-2/3 h-1/2 opacity-70">
                                    <span class="flex-1 bg-[#AD46FF]/30 rounded-sm" style="height: 40%"></span>
                                    <span class="flex-1 bg-[#AD46FF]/50 rounded-sm" style="height: 70%"></span>
                                    <span class="flex-1 bg-[#AD46FF]/40 rounded-sm" style="height: 55%"></span>
                                    <span class="flex-1 bg-[#AD46FF]/60 rounded-sm" style="height: 90%"></span>
                                    <span class="flex-1 bg-[#AD46FF]/35 rounded-sm" style="height: 50%"></span>
                                    <span class="flex-1 bg-[#AD46FF]/55 rounded-sm" style="height: 80%"></span>
                                </div>
                                <span
                                    class="absolute top-0.5 right-1 text-[9px] font-semibold text-[#AD46FF]/70 uppercase tracking-wider">
                                    {{ item.colSpan }}/12
                                </span>
                            </div>
                            <!-- Width selector — minimize/maximize chips step
                             through [4 → 6 → 8 → 12] widths. -->
                            <div class="flex items-center gap-1.5">
                                <span
                                    class="text-[10px] font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wide mr-0.5">Width</span>

                                <!-- Decrease -->
                                <button type="button"
                                    (click)="decreaseEditorCardColSpan(item.id); $event.stopPropagation()"
                                    [disabled]="!canDecreaseEditorCardColSpan(item)"
                                    class="p-1 rounded-md border transition-all"
                                    [ngClass]="canDecreaseEditorCardColSpan(item)
                                    ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                                    : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'"
                                    title="Decrease width">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="4 14 10 14 10 20" />
                                        <polyline points="20 10 14 10 14 4" />
                                        <line x1="14" y1="10" x2="21" y2="3" />
                                        <line x1="3" y1="21" x2="10" y2="14" />
                                    </svg>
                                </button>

                                <!-- Current width pill — Small / Medium / Large / Full -->
                                <span
                                    class="inline-flex items-center justify-center min-w-[58px] h-[20px] px-2 rounded-md text-[10px] font-semibold bg-[#AD46FF]/10 text-[#AD46FF] border border-[#AD46FF]/20 select-none whitespace-nowrap">
                                    {{ getEditorColSpanLabel(item.colSpan) }}
                                </span>

                                <!-- Increase -->
                                <button type="button"
                                    (click)="increaseEditorCardColSpan(item.id); $event.stopPropagation()"
                                    [disabled]="!canIncreaseEditorCardColSpan(item)"
                                    class="p-1 rounded-md border transition-all"
                                    [ngClass]="canIncreaseEditorCardColSpan(item)
                                    ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                                    : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'"
                                    title="Increase width">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="15 3 21 3 21 9" />
                                        <polyline points="9 21 3 21 3 15" />
                                        <line x1="21" y1="3" x2="14" y2="10" />
                                        <line x1="3" y1="21" x2="10" y2="14" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                }

                @if (editorItems().length === 0) {
                <div class="text-center py-16 text-slate-500 dark:text-slate-400">
                    <p class="text-sm">No layout items to customize.</p>
                </div>
                }
            </div>

            <!-- Footer -->
            <div
                class="flex items-center justify-between gap-3 px-5 sm:px-6 py-3.5 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
                <button type="button" (click)="resetLayoutEditorToDefaults()"
                    class="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5 transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                        <path d="M3 3v5h5" />
                    </svg>
                    Set Default
                </button>

                <div class="flex items-center gap-2">
                    <button type="button" (click)="closeLayoutEditor()"
                        class="px-4 py-2 rounded-lg text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors">
                        Cancel
                    </button>
                    <button type="button" (click)="applyLayoutEditor()" [disabled]="editorVisibleCount() === 0"
                        class="px-5 py-2 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-[#AD46FF] to-[#7c3aed] hover:shadow-lg hover:shadow-[#AD46FF]/30 hover:-translate-y-px disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 transition-all">
                        Apply
                    </button>
                </div>
            </div>
        </div>
    </div>
    }